<script lang="ts">
export type ElTabItem = {
  value?: string;
  label: string;
  disabled?: boolean;
  badge?: {
    visible: boolean;
    value?: string;
  };
};
</script>

<script lang="ts" setup>
import ElTab, { ElTabColors, ElTabStatues } from '@/ElTab.vue';
import ElInputSelect from '@/forms/ElInputSelect.vue';

const props = withDefaults(
  defineProps<{
    modelValue: string;
    tabs: ElTabItem[];
    color?: ElTabColors;
    variant?: 'default' | 'w-full';
  }>(),
  {
    color: undefined,
    variant: 'default',
  },
);

const emit = defineEmits<{
  (event: 'update:modelValue', modelValue: string): void;
}>();

const onClick = (tab: string) => {
  emit('update:modelValue', tab);
};

const getTabStatus = (tab: ElTabItem): ElTabStatues => {
  if (tab.disabled) return 'inactive';
  if ((tab.value ?? tab.label) === props.modelValue) return 'active';
  return 'default';
};
</script>

<template>
  <div class="w-full">
    <div class="hidden sm:flex flex-wrap">
      <ElTab
        v-for="(tab, index) in tabs"
        :key="`tab-${index}`"
        :color="props.color"
        :badge="tab.badge"
        :class="{ grow: props.variant === 'w-full' }"
        :label="tab.label"
        :status="getTabStatus(tab)"
        @click="onClick(tab.value ?? tab.label)"
      />
    </div>
    <div class="sm:hidden">
      <ElInputSelect
        :model-value="props.modelValue"
        :options="tabs.filter(item => !item.disabled).map(item => ({ label: item.label.toUpperCase(), value: item.value ?? item.label }))"
        @update:model-value="value => value && onClick(Array.isArray(value) ? value[0] : value)"
      />
    </div>
  </div>
</template>
